module.exports = __webpack_public_path__ + "img/tm.tma9bdcd1.svg";